import {
  ErrorState,
  ExtThemes,
  ButtonKind,
  WidthState,
  Column,
  Themes,
  PositionState,
} from '@usitsdasdesign/dds-ng/shared';
import { IntakeConstant } from '../../constants/intake.constant';
import { RadioButton, RadioGroupOptions } from '@usitsdasdesign/dds-ng/radio';
import { ButtonOptions } from '@usitsdasdesign/dds-ng/button';
import { SearchOptions } from '@usitsdasdesign/dds-ng/search';
import { IntakeOppertunitySubmissionStatus } from '../../constants/intake-submission-status.enum';
import { IntakeSubmissionDetailsCommonSectionDataSendingModal } from '../../../common/models/intake-submission-details-common-section.model';
import { ToastOptions } from '@usitsdasdesign/dds-ng/toast';
import { DropdownOptions } from '@usitsdasdesign/dds-ng/dropdown';
import { TooltipOptions } from '@usitsdasdesign/dds-ng/tooltip';
import {
  SharedConstant,
  SilentButtonBaseOption,
} from '../../../common/constants/shared.constant';

export const RADIO_GROUP_OPTIONS_FOR_RFP: RadioGroupOptions = {
  name: 'RelatedtoRFP',
  disabled: false,
  isError: false,
  errorState: ErrorState.default,
  isUncheckable: false,
  title: 'Is this proposal in response to a "Request for Proposal (RFP)?',
  isRequired: true,
  isInverse: false,
};

export const REP_RADIO_GROUP_VALUE: RadioButton[] = [
  {
    options: {
      label: 'Yes',
      theme: IntakeConstant.INTAKE_CHECKBOX_THEME_COLOR,
      disabled: undefined,
    },
    value: 'yes',
  },
  {
    options: {
      label: 'No',
      theme: IntakeConstant.INTAKE_CHECKBOX_THEME_COLOR,
    },
    value: 'no',
  },
];

export const RADIO_GROUP_OPTIONS_FOR_OTHER_SUBTYPE: RadioGroupOptions = {
  name: 'OtherSubtype',
  disabled: false,
  isError: false,
  errorState: ErrorState.default,
  isUncheckable: false,
  title: 'Submission subtype',
  isRequired: true,
  isInverse: false,
};
export const RADIO_GROUP_OPTIONS_FOR_CO_CHANGE_SCOPE: RadioGroupOptions = {
  name: 'COChangeScope',
  disabled: false,
  isError: false,
  errorState: ErrorState.default,
  isUncheckable: false,
  title:
    'Is the Change Order limited to changing only the timeline, effort (resources), and/or fees?',
  isRequired: true,
  isInverse: false,
};

export const CO_CHANGE_SCOPE_RADIO_GROUP_VALUE: RadioButton[] = [
  {
    options: {
      label: 'Yes',
      theme: IntakeConstant.INTAKE_CHECKBOX_THEME_COLOR,
      disabled: undefined,
    },
    value: 'yes',
  },
  {
    options: {
      label: 'No',
      theme: IntakeConstant.INTAKE_CHECKBOX_THEME_COLOR,
    },
    value: 'no',
  },
];

// TODO: Use from shared.constant.ts
export const SwapButtonOptions: DropdownOptions = {
  ...SilentButtonBaseOption,
  theme: ExtThemes.dark,
  kind: ButtonKind.silent,
  icon: IntakeConstant.DDS_ICON_ARROW_DOWN,
  ariaLabel: 'Select Action',
  isResponsive: false,
  stickerWidth: 300,
  stickerIsOutsideClick: false,
  stickerShift: 0,
  stickerMaxHeight: '',
  stickerIsDisabled: false,
  stickerPosition: PositionState.bottomRight,
  stickerIndent: 0,
  stickerCustomClass: '',
  stickerIsDynamic: true,
};

// TODO: Use from shared.constant.ts
export const SHOW_MORE_BTN_OPTIONS: ButtonOptions = {
  theme: ExtThemes.green,
  kind: ButtonKind.silent,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  icon: IntakeConstant.DDS_ICON_ARROW_DOWN,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: 'Show Less',
  customClass: IntakeConstant.EMPTY_SPACE,
  role: 'button',
};

export const CO_SEARCH_OPTION: SearchOptions = {
  placeholder:
    IntakeConstant.SEARCH_OPTION_PLACEHOLDER_FOR_COMMON_CO_WITHOUT_EL_SOW,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  customClass: IntakeConstant.EMPTY_SPACE,
};

// TODO: Remove
export const COMMON_BTN_OPTIONS: any = {
  theme: ExtThemes.green,
  kind: ButtonKind.primaryLoud,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: true,
  customClass: IntakeConstant.EMPTY_SPACE,
  role: 'button',
};
// TODO: Use from shared.constant.ts
export const PrimaryButton: ButtonOptions = {
  theme: ExtThemes.green,
  kind: ButtonKind.primary,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  icon: IntakeConstant.EMPTY_SPACE,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: 'Button',
  customClass: IntakeConstant.EMPTY_SPACE,
  role: 'button',
};

// TODO: Use primaryloudbase from shared.constant.ts
export const SUBMIT_BTN_OPTIONS: ButtonOptions = {
  ...COMMON_BTN_OPTIONS,
  icon: IntakeConstant.EMPTY_SPACE,
  customClass: IntakeConstant.EMPTY_SPACE,
  ariaLabel: IntakeConstant.SUBMIT_BTN_LABEL,
};

// TODO: Use from shared.constant.ts
export const ADD_REVIEWER_BTN_OPTIONS: ButtonOptions = {
  ...COMMON_BTN_OPTIONS,
  kind: ButtonKind.silent,
  customClass: IntakeConstant.EMPTY_SPACE,
  icon: 'dds-icon_plus',
  isIconLeft: false,
  ariaLabel: IntakeConstant.ADD_REVIEWER_BTN_LABEL,
};

// TODO: Use primaryloudbase from shared.constant.ts
export const ARCHIVE_AND_COMPLETE_BTN_OPTIONS: ButtonOptions = {
  ...COMMON_BTN_OPTIONS,
  icon: IntakeConstant.EMPTY_SPACE,
  customClass: IntakeConstant.EMPTY_SPACE,
  ariaLabel: IntakeConstant.ARCHIVE_AND_COMPLETE_BTN_LABEL,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  kind: ButtonKind.primaryLoud,
};

// TODO: Use primarybase from shared.constant.ts
export const RESUBMIT_FOR_REVIEW_BTN_OPTIONS: ButtonOptions = {
  ...COMMON_BTN_OPTIONS,
  icon: IntakeConstant.EMPTY_SPACE,
  customClass: IntakeConstant.EMPTY_SPACE,
  ariaLabel: IntakeConstant.RESUBMIT_FOR_REVIEW_BTN_LABEL,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  kind: ButtonKind.primary,
};

// TODO: Use primaryloudbase from shared.constant.ts
export const SELF_REVIEW_BTN_OPTIONS: ButtonOptions = {
  ...COMMON_BTN_OPTIONS,
  icon: IntakeConstant.EMPTY_SPACE,
  customClass: IntakeConstant.EMPTY_SPACE,
  ariaLabel: IntakeConstant.SELF_REVIEW_BTN_LABEL,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  kind: ButtonKind.primaryLoud,
};

// TODO: Use secondarybase from shared.constant.ts
export const OPT_OUT_SELF_REVIEW_BTN_OPTIONS: ButtonOptions = {
  ...COMMON_BTN_OPTIONS,
  icon: IntakeConstant.EMPTY_SPACE,
  customClass: IntakeConstant.EMPTY_SPACE,
  ariaLabel: IntakeConstant.OPT_OUT_OF_SELF_REVIEW_BTN_LABEL,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  kind: ButtonKind.secondary,
};

// TODO: Use from shared.constant.ts
export const SecondaryButton: ButtonOptions = {
  theme: ExtThemes.green,
  kind: ButtonKind.secondary,
  size: IntakeConstant.UI_ELEMENT_SIZE,
  width: WidthState.fixed,
  isLoading: false,
  icon: IntakeConstant.EMPTY_SPACE,
  isIconLeft: false,
  isColorBg: false,
  isInverse: false,
  disabled: false,
  ariaLabel: 'Button',
  customClass: IntakeConstant.EMPTY_SPACE,
  role: 'button',
};

// TODO: Use from shared.constant.ts
export const DarkTooltipOptions: TooltipOptions = {
  tooltipInvokeType: 'hover',
  tooltipPosition: 'top',
  tooltipIndent: 15,
  tooltipHasBeak: true,
  tooltipType: 'regular',
  tooltipSize: 'md',
  tooltipTheme: Themes.dark,
  tooltipMaxWidth: 300,
};

export const CompleteReviewPopUpTableHeader: Column[] = [
  { name: 'title', header: 'Title', dataType: 'string', minWidth: '14.375rem' },
  { name: 'Status', header: 'Status', dataType: 'number', minWidth: '8.75rem' },
];

// TODO: Use from shared.constant.ts
export const intakeToastOption: ToastOptions = {
  title: IntakeConstant.EMPTY_SPACE,
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const toastMessage: ToastOptions = {
  title: 'Review Completed',
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  closeBtnIcon: 'dds-icon_close',
  isCloseIcon: false,
  customClass: 'simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const submittedMessage: ToastOptions = {
  title: 'The request has been submitted to Risk Management for review.',
  message:
    'Please plan on a minimum of 2 business days for Risk Management to complete the review. If more time is needed due to complexity, or involvement of risk specialists or OGC, Risk Management will provide an update.',
  lifeTime: 6000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const returnForReworkMessage: ToastOptions = {
  title: 'Returned for revisions',
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const resubmittedToastMessage: ToastOptions = {
  title: 'Re-submitted',
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const completedToastMessage: ToastOptions = {
  title: 'Completed',
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const withoutRmToastMessage: ToastOptions = {
  title: 'Your request is saved in the system.',
  message: SharedConstant.EMPTY_STRING,
  lifeTime: SharedConstant.TEXT_MAX_LENGTH_5000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

export function isSelfReviewButtonVisible(
  selfReviewEligibilityValue: string,
  docStatus: IntakeOppertunitySubmissionStatus | null,
  reasonForOptOutSelfReview: string | undefined | null
): boolean {
  return (
    selfReviewEligibilityValue === IntakeConstant.YES &&
    (docStatus === IntakeOppertunitySubmissionStatus.DRAFT ||
      docStatus === IntakeOppertunitySubmissionStatus.RETURN_FOR_REWORK) &&
    !reasonForOptOutSelfReview
  );
}

// TODO: Use ToastBaseOptions from shared.constant.ts
export const optedOutSelfReviewToastMessage: ToastOptions = {
  title: 'Opted-out of self-review',
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};
export const optedOutSelfReviewToastMessageRM: ToastOptions = {
  title: 'Please submit for risk management review',
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

// TODO: Use ToastBaseOptions from shared.constant.ts
export const riskManagerAssignmentDelayMessage: ToastOptions = {
  title: IntakeConstant.EMPTY_SPACE,
  message: IntakeConstant.EMPTY_SPACE,
  lifeTime: 3000,
  withProgressBar: false,
  position: 'bottom-center',
  isCloseIcon: false,
  customClass: 'toast-align simple-toast',
  isError: false,
  isInverse: false,
  isLoading: false,
  limit: 5,
  theme: Themes.dark,
};

export function setWbsAndArchiveDetails(
  model: IntakeSubmissionDetailsCommonSectionDataSendingModal,
  isWBSPending: boolean
): any {
  return {
    archiveID: model.archiveID,
    archiveNumber: model.isArchiveNotAvailable
      ? IntakeConstant.ARCHIVE_NOT_LISTED
      : model.archiveNumber,
    archiveName: model.archiveName,
    archiveFoldersArray: model.archiveFoldersArray,
    archiveFolder: model.archiveFolder,
    business: model.business,
    clientNumber: model.clientNumber,
    clientName: model.clientName,
    partner: model.partner,
    archiveDescription: model.archiveDescription,
    archiveStatus: model.archiveStatus,
    wbsChargeCode: model.wbsChargeCode ?? IntakeConstant.EMPTY_SPACE,
    wbsDescription: model.wbsDescription ?? IntakeConstant.EMPTY_SPACE,
    isWBSPending: isWBSPending,
  };
}

export enum UpdateReviewerActions {
  ADD = 'add',
  DELETE = 'delete',
  TOGGLE = 'toggleRow',
}
